export const appUpdateText = {
	message:
		'A new version of the app has been deployed. Please update to get the latest features and improvements.',
	updateButton: 'Update now',
};
